import { render, staticRenderFns } from "./DeadEndLayout.vue?vue&type=template&id=b1c8f9d2"
import script from "./DeadEndLayout.vue?vue&type=script&lang=ts"
export * from "./DeadEndLayout.vue?vue&type=script&lang=ts"
import style0 from "./DeadEndLayout.vue?vue&type=style&index=0&id=b1c8f9d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports